import { render, staticRenderFns } from "./SingleTextQuestion.vue?vue&type=template&id=99fb6a0c&scoped=true&"
import script from "./SingleTextQuestion.vue?vue&type=script&lang=ts&"
export * from "./SingleTextQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fb6a0c",
  null
  
)

export default component.exports